import { Chip } from '@mui/material'
import { styles } from './styles'
import type { CompanyStatusProps } from './types'
import { CompanyStatus as Status } from '@/api/models/company'

export const CompanyStatus = ({ status }: CompanyStatusProps) => {
  if (status) {
    switch (status) {
      case Status.CONFIRMED:
        return (
          <Chip
            sx={styles.chip}
            variant={'outlined'}
            color="success"
            label={'Действует'}
          />
        )
      case Status.DRAFT:
        return (
          <Chip
            sx={{
              ...styles.chip,
              color: '#787878',
              borderColor: '#8E8E8E',
              backgroundColor: '#EEEEEE',
            }}
            variant={'outlined'}
            label={'Черновик'}
          />
        )
      // case 'DELETED':
      //   return (
      //     <Chip
      //       sx={styles.chip}
      //       variant={'outlined'}
      //       color="warning"
      //       label={'Заблокирована'}
      //     />
      //   )
      case Status.ACTIVE:
        return (
          <Chip
            sx={styles.chip}
            variant={'outlined'}
            color="success"
            label={'Действующая'}
          />
        )
      case Status.LIQUIDATED:
        return (
          <Chip
            sx={styles.chip}
            variant={'outlined'}
            color="error"
            label={'Ликвидирована'}
          />
        )
      case Status.LIQUIDATING:
        return (
          <Chip
            sx={styles.chip}
            variant={'outlined'}
            color="warning"
            label={'Ликвидируется'}
          />
        )
      default:
        return (
          <Chip
            sx={styles.chip}
            variant={'outlined'}
            color="primary"
            label={'...'}
          />
        )
    }
  }
}
